import React from 'react';
import { useNavigate } from 'react-router-dom';
import Button from '@mui/material/Button';
import { orange } from '@mui/material/colors';

const NotFoundPage = () => {

    const navigate=useNavigate();
    const primary=orange[800];

    return (
        <div className="row error-page">
            <div className='col-md-6 d-flex align-items-center'>
                <img src="./images/error.png" alt="" className='d-block mx-auto img-fluid' />
            </div>

            <div className='col-md-6 text-center error-page-summary d-flex align-items-center'>
                <div>
                    <h1>The page you looking for seems to be not exist.</h1>
                    <Button 
                        variant='contained'
                        className='login-logout-button'
                        style={{backgroundColor:primary}}
                        onClick={async ()=>{
                            navigate('/');
                        }}
                    >Home</Button>
                </div>
            </div>
        </div>
    );
}

export default NotFoundPage;